import React from 'react'

import Base from '../_Base'

const AuR = (props) => (
  <Base width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
    <path
      d="M24.0249 21.9975C24.0249 23.0983 23.123 24 22.0263 24H2.02349C0.922574 24 0.0249023 23.0983 0.0249023 21.9975V1.99824C0.0249023 0.897513 0.922574 0 2.02349 0H22.0263C23.1272 0 24.0249 0.897513 24.0249 1.99824V21.9975Z"
      fill="white"
    />
    <path
      d="M22.9319 21.0902C22.9319 22.0908 22.1121 22.9106 21.1154 22.9106H2.93447C1.93383 22.9106 1.11792 22.0908 1.11792 21.0902V2.90932C1.11792 1.90868 1.93383 1.09277 2.93447 1.09277H21.1154C22.116 1.09277 22.9319 1.90868 22.9319 2.90932V21.0902Z"
      fill="#231F20"
    />
    <path
      d="M15.2422 13.878V10.0948L14.4456 10.7953V10.3027L15.2422 9.61377H15.6733V13.878H15.2422Z"
      fill="white"
    />
    <path
      d="M17.5478 13.9126C16.8397 13.9126 16.2893 13.42 16.2893 12.7042C16.2893 12.2077 16.5703 11.8729 16.932 11.6689C16.5972 11.4765 16.374 11.1686 16.374 10.7221C16.374 10.0563 16.8704 9.5791 17.5478 9.5791C18.2252 9.5791 18.7216 10.0602 18.7216 10.7221C18.7216 11.1647 18.5061 11.4765 18.1713 11.6689C18.5292 11.8729 18.8063 12.2077 18.8063 12.7042C18.8063 13.4239 18.256 13.9126 17.5478 13.9126ZM17.5478 11.8652C17.0821 11.8652 16.7204 12.2231 16.7204 12.6965C16.7204 13.1699 17.0783 13.5278 17.5478 13.5278C18.0173 13.5278 18.3753 13.1699 18.3753 12.6965C18.3753 12.2231 18.0173 11.8652 17.5478 11.8652ZM17.5478 9.96011C17.1091 9.96011 16.805 10.2834 16.805 10.726C16.805 11.1686 17.1091 11.488 17.5478 11.488C17.9865 11.488 18.2906 11.1763 18.2906 10.726C18.2906 10.2757 17.9865 9.96011 17.5478 9.96011Z"
      fill="white"
    />
    <path
      d="M20.8767 12.4769V13.5314H20.4764V12.4769H19.4219V12.0767H20.4764V11.0337H20.8767V12.0767H21.9235V12.4769H20.8767Z"
      fill="white"
    />
    <path
      d="M9.09604 14.9401L7.96455 12.631H7.15249V14.9401H6.021V9.14795H8.29168C9.47321 9.14795 10.1698 9.95231 10.1698 10.9222C10.1698 11.7381 9.67334 12.2422 9.11144 12.4462L10.4046 14.944H9.09604V14.9401ZM8.21471 10.1563H7.14864V11.6842H8.21471C8.71118 11.6842 9.03831 11.3686 9.03831 10.9222C9.03831 10.4757 8.71118 10.1563 8.21471 10.1563Z"
      fill="white"
    />
    <path
      d="M7.97223 6.13085L2.10693 11.9962L8.10693 17.9923L14.1031 11.9962L8.10309 6L7.97223 6.13085ZM8.10693 6.52726C8.35325 6.77357 13.3295 11.7498 13.5758 11.9962C13.3295 12.2425 8.35325 17.2149 8.10693 17.4612C7.86062 17.2149 2.88436 12.2386 2.63804 11.9962C2.88436 11.7498 7.86062 6.77357 8.10693 6.52726Z"
      fill="white"
    />
  </Base>
)

export default AuR
